<template>
    <v-form ref="form">
        <c-flip-card
            v-if   = "company"
            color  = "white--text"
            :top   = "8"
            :right = "8"
            :style = "'height:' + height + 'px'"
        >
            <template v-slot:front>
                <div class="w-100">
                    <v-row class="no-frame w-100" >
                        <div class="lm-border v-flex primary w-100"
                             style="height: 30px; border-radius: 4px; padding-top: 2px"
                        >
                            <div class="pl-2 white--text">
                                Unternehmen - {{ company.id }}
                            </div>
                            <v-spacer />
                            <div class="white--text pr-3" v-if="company && company.status">
                                {{ company.status.name }}
                            </div>

                            <slot name="toolbar"></slot>
                            <v-tooltip bottom v-if="company.weburl">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="pr-0" >
                                        <a
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.stop="onWeb"
                                        >
                                            <v-icon size="20" class="pr-1 white--text">mdi-web</v-icon>
                                        </a>
                                    </div>
                                </template>
                                <span>Web-Site des Kunden</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="showStore">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="pr-6">
                                        <a
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.stop="onStore"
                                        >
                                            <v-icon size="20" class="pr-1 white--text">mdi-content-save</v-icon>
                                        </a>
                                    </div>
                                </template>
                                <span>Kundendaten speichern</span>
                            </v-tooltip>
                        </div>
                    </v-row>
                    <v-row class="no-frame w-100 mt-1" style="height: calc(100% - 30px)">
                        <div
                            class="lm-border pa-3 pt-2 pb-0 h-100"
                            style="width: calc(100% - 1px)"
                        >
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-text-field
                                        label          = "Name"
                                        v-model        = "company.name"
                                        :rules         = "[rules.required, uniqueValidation]"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-textarea
                                        class="mb-1"
                                        label          = "Zusatz"
                                        v-model        = "company.nameAdd"
                                        rows="2"
                                        no-resize
                                        hide-details
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <!--
                                                    <v-row class="no-frame">
                                                        <v-text-field
                                                            label="Zusatz"
                                                            v-model="company.nameAdd"
                                                        />
                                                    </v-row>
                            -->
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <f-enum-select
                                        v-model = "company.country"
                                        label   = "Land"
                                        module  = "msd"
                                        type    = "countries"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="col-3 no-frame pr-2">
                                    <v-text-field
                                        label="PLZ"
                                        v-model="company.zip"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                                <v-col class="col-9 no-frame pl-2">
                                    <v-text-field
                                        label="Stadt"
                                        v-model="company.city"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>

                            <v-row class="no-frame">
                                <v-text-field
                                    label="Strasse"
                                    v-model="company.street"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-row>

                            <slot name="roles" />
                        </div>

                    </v-row>
                </div>
            </template>
            <template v-slot:back>
                <div class="w-100 h-100">
                    <c-column-header
                        label="Unternehmen"
                        class="primary w-100"
                        style="font-size: 16px;"
                    >
                        <template v-slot:filter>
                            <div class="white--text pr-3" v-if="company && company.status">
                                {{ company.status.name }}
                            </div>

                            <v-tooltip bottom v-if="showStore">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="pr-6">
                                        <a
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.stop="onStore"
                                        >
                                            <v-icon size="20" class="pr-1 white--text">mdi-content-save</v-icon>
                                        </a>
                                    </div>
                                </template>
                                <span>Kundendaten speichern</span>
                            </v-tooltip>
                        </template>
                    </c-column-header>
                    <div
                        class="lm-border pa-3 pt-3 pb-0 mt-1"
                        style="height: calc(100% - 30px); width: calc(100% - 1px)"
                    >
                        <slot name="additional" />
                        <v-row class="no-frame" v-if="showWeb">
                            <v-text-field
                                label="Web"
                                v-model="company.weburl"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-row>

                        <v-row class="no-frame mb-2" v-if="company.dtype !== 2">
                            <v-col class="no-frame col-5 pr-2">
                                <v-select
                                    :items="status"
                                    item-value="id"
                                    item-text="name"
                                    label="Status"
                                    :readonly = "true"
                                    v-model="company.status"
                                    @change="onStatus"
                                />
                            </v-col>
                            <v-col class="no-frame col-7 pl-2">
                                <inc-manufacturer
                                    v-if="company.status === 2"
                                    v-model="manufacturer"
                                    label="Neues Unternehmen"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-4">
                            <v-textarea
                                label="Notizen"
                                v-model="company.comment"
                                no-resize
                                :rows          = "commentRows"
                                class          = "pt-0"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-row>
                    </div>
                </div>
            </template>
        </c-flip-card>
    </v-form>
</template>

<script>

import CFlipCard       from "@/modules/core/components/utils/CFlipCard";
import CColumnHeader   from "@/modules/core/components/utils/CColumnHeader";
import IncManufacturer from "@/modules/inc/steps/components/common/IncManufacturer";
import Company         from "@/modules/msd/company/common/service/Company";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import Core from "@/modules/core/service/Core";

export default {
    name: "CompanyEdit",

    components: {
        FEnumSelect,
        IncManufacturer,
        CColumnHeader,
        CFlipCard
    },

    props: {
        company: {
            required: false,
            type    : Object,
            default : function () {
                return {
                    weburl: null,
                }
            }
        },

        height: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        commentRows: {
            required: false,
            type    : Number,
            default : function () {
                return 11;
            }
        },

        showStore: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        showWeb: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    data: () => ({
        manufacturer: null,
        unique: true,
    }),

    computed: {
        status () {
            return this.$store.getters.companyStatus;
        },

        rules () {
            return Core.rule;
        },
    },

    methods: {
        onStore (success, error) {
            this.unique = true;
            if (!this.$refs.form.validate ()) {
                return;
            }

            Company.store (this, this.company, (data) => {
                this.$emit("stored", data);
                if (success) success(data);
            }, (info) => {
                if (error) error (info);
                if (info && info.id && info.id === 'msd.company.notunique') {
                    this.unique = false;
                    this.$refs.form.validate ();
                }
            });
        },

        onWeb () {
            const url = this.company.weburl.startsWith("http") ? this.company.weburl : "http" + this.company.weburl;
            window.open(url, '_blank');
        },

        onStatus () {
            console.log(this.company.status)
        },

        uniqueValidation () {
            if (!this.unique) {
                return "Name wird bereits verwendet"
            }
            return true;
        }
    }
}
</script>

<style scoped>

</style>